app.service("productInstalmentsSection", function (productInstalmentsModal, modal, loading, message) {
	let $self, $changeInstalmentBtn, $howtoUseBtn;

	function init(props) {
		setElements(props);
		setEvents();
	}

	function setElements(props) {
		$self = props.$el.find('.instalments-section');
		$howtoUseBtn = props.$el.find('.how-to-use-button');
		$changeInstalmentBtn = props.$el.find('.change-instalment-button');
	}

	function setEvents() {
		$changeInstalmentBtn.click(openInstalmentsModal);
		$howtoUseBtn.click(openHowToUseModal);
	}

	function openInstalmentsModal() {
		productInstalmentsModal.show();
		UA.interaction('KP_Crossell', 'Raty', 'Zmien_liczbe_rat');
	}

	function openHowToUseModal() {
		loading.start();
		message.get('product-card-instalment-benefits-modal').then((html) => {
			loading.stop();
			modal.generate({
				id: 'how-to-use-instalment',
				content: html
			})
		});
	}

	return {
		init: init
	};
});